import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'vipps-btn',
  templateUrl: './vipps-btn.component.html',
  styleUrls: ['./vipps-btn.component.scss']
})
export class VippsBtnComponent implements OnInit {
  @Input() size = 'xl';
  @Input() selected: boolean;
  @Input() extraClasses: string = '';

  constructor() {
  }

  ngOnInit() {
  }

}
